import React from 'react'
import { TFunction } from 'i18next'
import './ConfirmationAsideContent.scss'

export const ConfirmationAsideContent = (t: TFunction): JSX.Element => {
  const tRoot = 'bluebook.aside.confirmation.description'
  return (
    <div className='confirmation-aside-content'>
      <p>{`${t(`${tRoot}.confirmYourInformation`)}`}</p>
      <p>
        {`${t(`${tRoot}.ifAnyDataIsWrong`)} `}
        <a
          className='confirmation-aside-content__link'
          href='https://help.conekta.com/'
          target='_blank'
          rel='noopener noreferrer'
        >
          {`${t(`${tRoot}.customerSupport`)}`}
        </a>
      </p>
    </div>
  )
}
